module.exports = __webpack_public_path__ + "c1d145e3056a477226bcfaf66339c16e.png";